module.exports = __webpack_public_path__ + "static/item_font_size_example-6acbefe923350f38b40623dc53dc5d3e.png";